import { useState } from 'react'
import { ExpandMore } from '@mui/icons-material'
import { Button, ButtonProps, Menu, MenuItem, Typography } from '@mui/material'

type Option = {
  label: string
  value: string | number
}

interface DropdownProps extends Omit<ButtonProps, 'onSelect'> {
  label: string
  options: Option[]
  onSelect?: (value: string | number) => void
}

export function Dropdown({
  label,
  options,
  onSelect,
  ...props
}: DropdownProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>()
  const [value, setValue] = useState<string | number>()

  const isOpen = Boolean(anchorEl)

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => setAnchorEl(undefined)

  const handleSelectOption = (value: string | number) => {
    setValue(value)
    handleClose()

    if (onSelect) {
      onSelect(value)
    }
  }

  label = options.find((option) => option.value === value)?.label || label

  return (
    <>
      <Button
        variant="text"
        onClick={handleOpen}
        endIcon={
          <ExpandMore
            sx={{
              rotate: isOpen ? '180deg' : undefined,
              transition: '200ms',
            }}
          />
        }
        {...props}
      >
        <Typography noWrap fontWeight={500}>
          {label}
        </Typography>
      </Button>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {options.map(({ label, value }) => (
          <MenuItem key={value} onClick={() => handleSelectOption(value)} dense>
            <Typography noWrap>{label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
